var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.586 11.997L9.313 8.019L9.248 6.29H11.172L11.107 8.019L10.834 11.997H9.586ZM10.21 15.156C9.88067 15.156 9.60333 15.0433 9.378 14.818C9.16133 14.584 9.053 14.298 9.053 13.96C9.053 13.6133 9.16133 13.3273 9.378 13.102C9.60333 12.868 9.88067 12.751 10.21 12.751C10.5393 12.751 10.8123 12.868 11.029 13.102C11.2543 13.3273 11.367 13.6133 11.367 13.96C11.367 14.298 11.2543 14.584 11.029 14.818C10.8123 15.0433 10.5393 15.156 10.21 15.156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.fa1733507718d393381f0e78b11e5eef.svg";
export { ForwardRef as ReactComponent };